import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "./SplitNumber";
import AddToBasketButton from "./addToBasketButton";
import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "./addToBasketRoundedButton";
import { IconStar, IconTooman } from "../../assets/icons";
import placeHolderimage from "../../assets/images/load-image.jpg";
import useLazyLoad from "./LazyImage";
function CardTile({
  itemImgSrc,
  amusementUrl,
  amusementName,
  amusementPrice,
  amusementFinalPrice,
  handleClick,
  tafrihanSuggestion,
  imageLabelJson,
}) {
  const [imageLabels, setImageLabels] = useState([]);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [ref, inView] = useLazyLoad({ threshold: 0.1 }); // وقتی 10% المان در viewport باشد

  useEffect(() => {
    var imageLabelList = JSON.parse(imageLabelJson || "[]");
    setImageLabels(imageLabelList);
  }, [imageLabelJson]);
  return isMobile ? (
    <Link to={amusementUrl}>
      <Card className="p-1 rounded-3 text-center box-shadow-sm h-100">
        {tafrihanSuggestion && (
          <div
            className="rounded-3 fs-07 center-tag-1 px-2 py-1 position-absolute"
            style={{ top: "0px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconStar fillColor="#9b8705" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )}

        <div
          ref={ref}
          style={{ position: "relative", width: "100%", height: "108px" }}
        >
          {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
          <img
            src={placeHolderimage}
            data-src={`${itemImgSrc}?width=200`}
            altBot={amusementName}
            alt=""
            aria-hidden="true"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />

          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={`${itemImgSrc}?width=200`}
                alt={amusementName}
                className={`rounded-3 mb-1 w-100 ${
                  isImageLoaded ? "visible" : "invisible"
                }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="tag-on-pic">
                {imageLabels.map((label) => (
                  <div
                    key={label.id}
                    className="rounded-start-2 text-white fs-075 px-2 mt-1"
                    style={{ background: label.BackgroundColor }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: label.LabelText,
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        {/* <div className="position-relative">
          <Card.Img
            variant="top"
            src={itemImgSrc + "?width=200"}
            className="rounded-3"
          />
          <div className="tag-on-pic">
            {imageLabels.map((label) => (
              <div
                key={label.id}
                className=" rounded-start-2 text-white fs-075 px-2 mt-1"
                style={{ background: label.BackgroundColor }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: label.LabelText,
                  }}
                />
              </div>
            ))}
          </div>
        </div> */}
        <Card.Body className="mx-2 px-0 pt-2 pb-1 mb-1 border-bottom">
          <h3 className="text-black d-inline-block mb-1 fw-bold fs-08">
            {amusementName}
          </h3>
        </Card.Body>
        <Card.Footer className="bg-white border-0 pb-2 pt-1 px-1 position-relative rounded-bottom-3">
          <Row className="gx-0">
            <Col className="my-auto">
              <div className="d-flex align-items-center justify-content-around">
                {amusementFinalPrice > amusementPrice && (
                  <>
                    <span className="text-black-06 fs-07 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    {/* <span className="fs-08 ps-1">تومان</span> */}
                  </>
                )}

                <div className="fw-bold text-black d-flex align-items-center">
                  <span className=" text-dark">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  <span className=" mb-2 medium-svg">
                    <IconTooman fillColor="#000" />
                  </span>
                </div>
              </div>
            </Col>
            <Col xs="12" className="my-auto">
              <AddToBasketRoundedButton onClick={handleClick} />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </Link>
  ) : (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center box-shadow-sm h-100">
        {tafrihanSuggestion && (
          <div
            className="  rounded-3 fs-07 center-tag-1 px-2 py-1 position-absolute"
            style={{ top: "-6px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconStar fillColor="#9b8705" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )}
        <div
          ref={ref}
          style={{ position: "relative", width: "100%", height: "140px" }}
        >
          {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
          <img
            src={placeHolderimage}
            data-src={`${itemImgSrc}?width=210`}
            altBot={amusementName}
            alt=""
            aria-hidden="true"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />

          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={`${itemImgSrc}?width=210`}
                alt={amusementName}
                className={`rounded-3 mb-1 w-100 ${
                  isImageLoaded ? "visible" : "invisible"
                }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="tag-on-pic">
                {imageLabels.map((label) => (
                  <div
                    key={label.id}
                    className="rounded-start-2 text-white fs-075 px-2 mt-1"
                    style={{ background: label.BackgroundColor }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: label.LabelText,
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        {/* <div className="position-relative">
          <Card.Img
            variant="top"
            src={itemImgSrc + "?width=210"}
            className="rounded-3"
          />
          <div className="tag-on-pic">
            {imageLabels.map((label) => (
              <div
                key={label.id}
                className=" rounded-start-2 text-white fs-075 px-2 mt-1"
                style={{ background: label.BackgroundColor }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: label.LabelText,
                  }}
                />
              </div>
            ))}
          </div>
        </div> */}
        <Card.Body className="mx-2 px-0 pt-3 pb-1 mb-1 border-bottom">
          <h3 className="text-black fw-bold fs-normal ">{amusementName}</h3>

          {/* <AddToBasketButton
            
            price={amusementFinalPrice}
          /> */}
        </Card.Body>
        <Card.Footer className="bg-white border-0 pb-2 pt-1 px-1 position-relative rounded-bottom-3">
          <Row className="gx-0">
            <Col className="my-auto">
              <div className="d-flex align-items-center justify-content-around">
                {amusementFinalPrice > amusementPrice && (
                  <>
                    <span className="text-black-06 fs-07 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    {/* <span className="fs-08 ps-1">تومان</span> */}
                  </>
                )}

                <div className="fw-bold text-black d-flex align-items-center">
                  <span className=" text-dark">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  <span className=" mb-2 medium-svg">
                    <IconTooman fillColor="#000" />
                  </span>
                </div>
              </div>
            </Col>
            <Col xs="12" className="my-auto">
              <AddToBasketRoundedButton onClick={handleClick} />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </Link>
  );
}
export default CardTile;
